import { Path, Svg } from './styles';
import { IconProps } from './types';

/* eslint-disable max-len */
const path =
  'M11.0607 5.05594L6.66732 9.44927L4.27398 7.0626L3.33398 8.0026L6.66732 11.3359L12.0007 6.0026L11.0607 5.05594ZM8.00065 1.33594C4.32065 1.33594 1.33398 4.3226 1.33398 8.0026C1.33398 11.6826 4.32065 14.6693 8.00065 14.6693C11.6807 14.6693 14.6673 11.6826 14.6673 8.0026C14.6673 4.3226 11.6807 1.33594 8.00065 1.33594ZM8.00065 13.3359C5.05398 13.3359 2.66732 10.9493 2.66732 8.0026C2.66732 5.05594 5.05398 2.66927 8.00065 2.66927C10.9473 2.66927 13.334 5.05594 13.334 8.0026C13.334 10.9493 10.9473 13.3359 8.00065 13.3359Z';
/* eslint-enable max-len */

const IconCheckCircleOutline = ({ width = 16, height = 16, color, style, className }: IconProps) => (
  <Svg className={className} style={style} width={width} height={height} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <Path fillRule="evenodd" clipRule="evenodd" fill={color || 'currentColor'} d={path} />
  </Svg>
);

export default IconCheckCircleOutline;
